__webpack_require__.p = "https://static.amoreceitas.org/dist/";